module.exports = __webpack_public_path__ + "img/ecn.5609809a.gif";